import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RipuDatePipeFormat } from './pipe/ripu.datepipe';
import { SinoPipe } from './pipe/sino.pipe';
import { GoogleInputPlacesDirective } from './directives/googleinputplaces.directive';
import { CdcMultiselectComponent } from './cdc-multiselect/cdc-multiselect.component';


@NgModule({
    imports: [
        CommonModule, // CommonModule because the module's component needs common directives.
        CdcMultiselectComponent
    ],
    declarations: [
        RipuDatePipeFormat,
        SinoPipe,
        GoogleInputPlacesDirective
    ],
    providers: [RipuDatePipeFormat],
    exports: [
        CommonModule,
        RipuDatePipeFormat,
        SinoPipe,
        GoogleInputPlacesDirective,
        CdcMultiselectComponent
    ]
})
export class SharedModule { }
